module.exports = __webpack_public_path__ + "static/media/Ha-Thi-Thanh-Huong.ce513bff.png";